import { render, staticRenderFns } from "./PrivilegeHistoryTable.vue?vue&type=template&id=0a371853&scoped=true&"
import script from "./PrivilegeHistoryTable.vue?vue&type=script&lang=js&"
export * from "./PrivilegeHistoryTable.vue?vue&type=script&lang=js&"
import style1 from "./PrivilegeHistoryTable.vue?vue&type=style&index=1&id=0a371853&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a371853",
  null
  
)

export default component.exports